import { useEffect, useState } from "react";
import { API } from "@/lib/api";

export function useFileSrc(path) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!path) return;
    let mounted = true;
    let objectUrl = null;

    (async () => {
      try {
        const token = localStorage.getItem("df_token");
        const r = await fetch(`${API}/files/${path}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!r.ok) return;
        const blob = await r.blob();
        objectUrl = URL.createObjectURL(blob);
        if (mounted) setSrc(objectUrl);
      } catch {}
    })();

    return () => {
      mounted = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  return src;
}
